module.exports = __webpack_public_path__ + "105cdd982960c17c425fc656cb94d413.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/iconfont/iconfont.ttf?t=1570559747074
// module id = 14
// module chunks = 0